import { TextInput } from 'react-native';

export default TextInput;
